export default __webpack_public_path__ + "media/src/features/my-activity/assets/ratingIcon-08d9b9c54c6419d91d123b73fbf3dd49.svg";